import React, { useState } from "react"
import AsyncSelect from "react-select/async"
import styled from "styled-components"
import { apiVocByCritere } from "../api";

const Champ = styled.div`
margin:10px;
padding: 5px;
float left;
display: inline;
width:100%;
`

const Label = styled.div`
padding: 5px;
min-width: 250px;
`

const OpenthesoSelect = styled(AsyncSelect)`
margin: 10px;
max-width: 500px;
display: block;
`

/**
 * Construction des options du select
 * association numéro et nom de la variable
**/

let groupes = []
groupes['support'] = "MT92"
groupes['materiel'] = "MT_13"
groupes['lieu_origine'] = "MT98"
groupes['lieu_conservation'] = "MT98"
groupes['type_inscription'] = "MT94"

const numThesaurus = "4"

//support avec uri et label
const construitOptionOpentheso = (element) => {
  //console.log(element)
  const retour = {
    value: {
      uri: element.uri,
      label: element.label
    },
    label: element.label
  }
  return retour
}

const valeurs = (tableau) => {
  console.log(tableau)
  if ( ! tableau) {
    return []
  }
  return (tableau.map(element => construitOptionOpentheso(element)))
}

const valeurParDefaut = (element) => {
  if ( ! element) {
    return null
  } else {
    return ([construitOptionOpentheso(element)])
  }

}

const getLabel = (nom) => {
  switch (nom){
    case 'support':
      return 'Support d\'inscription'
      case 'materiel':
        return 'Matériel'
    case 'toponyme':
      return 'Toponyme'
    case 'ville':
      return 'Ville'
    case 'pays':
      return 'Pays'
    case 'type_inscription':
      return 'Type d\'inscription'
    default:
      return '!! Inconnue !!'
  }
}

//Element autocomplete avec valeur initiale
// {uri, label} et setField - Formik
const ElementFormOpentheso = (params) => {

  const {nom, initialValues, handleChange} = params
  const [maValeur, setMaValeur] = useState( initialValues ? valeurParDefaut(initialValues) : null)
  const groupe =  groupes[nom]

  const loadOptions = async (critere, callback) => {
    //console.log(critere + " groupe " + groupe)
    const retour = await apiVocByCritere(critere, numThesaurus, groupe)
    //const continentSaisi = document.forms[0].elements.continent.value
    //console.log("avant")
    //const retour = await apiPaysByCritereByContinent(critere, continentSaisi)
    let mesOptions = []
    mesOptions = valeurs(retour.reponse)
    callback(mesOptions)
   }

  const handleChangeOpenTheso = (monOption) => {
    console.log(monOption)
    setMaValeur(monOption)
    handleChange(monOption)
  }


  const placeHolder = "choix " + nom
//creation de l'element select multiple
  return (
    <Champ>
      <Label>{getLabel(nom)}</Label>
      <OpenthesoSelect
        name={nom}
        value={maValeur}
        defaultValue={maValeur}
        placeholder={placeHolder}
        isClearable={true}
        onChange={handleChangeOpenTheso}
        loadOptions={loadOptions}
      />
     </Champ>
  )

}
export default ElementFormOpentheso
